import { ParserVars } from '../types/Run';

/**
 * Return a ParserVars blob with `gps.force_gps_speed` set, preserving every
 * other sub-object and every other `gps` field (the source-gate overrides).
 * `null` removes the run-level setting so the session value is inherited.
 */
export function withForceGpsSpeed(
  pv: ParserVars | null | undefined,
  next: boolean | null,
): ParserVars {
  const gps = { ...(pv?.gps ?? {}), force_gps_speed: next };
  return { ...(pv ?? {}), version: pv?.version ?? 1, gps };
}
